var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasContractsForAgreement)?_c('button',{staticClass:"button primary mt-1",class:{ 'notValid': _vm.isNotValid },attrs:{"type":"button"},on:{"click":function($event){return _vm.showVertragszustimmung(_vm.bewerbung)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.messages['fh.vertragszustimmung.h2'])}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }